import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

interface CreateInputProps {
  type: string,
  error: boolean,
  label: string,
  errorMsg: string,
  preValue: string,
  stateName: any,
  setStateFunction: Function,
  option?: any
}

interface CreateDisabledInputProps {
  type: string,
  error: boolean,
  label: string,
  errorMsg: string,
  defaultValue: string,
}

const CreateInput = (props: CreateInputProps) => {

  const [inputData, setInputData] = useState('')

  const { type, error, label, errorMsg, stateName, setStateFunction, preValue = "", option } = props

  const onChangeHandler = (e: any, stateName: any, option: any) => {
    let shouldSetValue = true;
    const inputValue = e.target.value;
    if (type === 'number') {
      shouldSetValue = /^[0-9]{0,10}$/.test(inputValue);
    }
    if (type === 'year') {
      shouldSetValue = /^[0-9]{0,4}$/.test(inputValue);
    }
    if (type === 'pincode') {
      shouldSetValue = /^[0-9]{0,6}$/.test(inputValue);
    }
    if (shouldSetValue) {
      setInputData(inputValue)
      setStateFunction && setStateFunction(inputValue, stateName, option)
    }
  }

  useEffect(() => {
    onChangeHandler({ target: { value: preValue } }, stateName, option)
    // eslint-disable-next-line
  }, [preValue])

  return (
    <TextField
      fullWidth
      error={error}
      type={'text'}
      label={label}
      helperText={error && errorMsg}
      value={inputData}
      required
      onChange={e => { onChangeHandler(e, stateName, option) }}
      onBlur={e => { onChangeHandler(e, stateName, option) }}
    />
  )
}

export const CreateDisabledInput = (props: CreateDisabledInputProps) => {
  const { error, label, errorMsg, defaultValue } = props

  return (
    <TextField
      fullWidth
      error={error}
      label={label}
      helperText={error && errorMsg}
      disabled={true}
      required
      value={defaultValue}
    />
  )
}

export default CreateInput